@if (product$ | async; as product) {
  <section class="product-literature">
    @if (product?.additionalDatas && product.additionalDatas.length) {
      <div class="literature-container" >
        <h2 class="section-title">Product Literature</h2>
        <div class="literature-grid" >
          @for (
            doc of product?.additionalDatas; track
            doc) {
            @if (doc.productDetailType === 'LITERATURE') {
              <div class="literature-card">
                <div class="literature-content">
                  <h3 class="literature-title">{{ doc.title }}</h3>
                  <a
                    class="download-btn"
                    [href]="doc.mediaUrl"
                    target="_blank"
                    rel="noopener"
                    >
                    {{ 'productSummary.viewNow' | cxTranslate }}
                  </a>
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  </section>
}


